// components
import getIcon from "utils/getIcon";
import Label from "components/atoms/Label/Label";
import Button from "components/atoms/Button/Button";
import { Head } from "components/molecules/Head/Head";
import Spinner from "components/atoms/Spinner/Spinner";
import { Button as ANTButton, Form, Input } from "antd";
import PageTitle from "components/molecules/PageTitle/PageTitle";
import ErrorMessage from "components/molecules/ErrorMessage/ErrorMessage";
import ReimbursementVerificationReviewDetails from "components/organisms/ReimbursementVerificationReviewDetails/ReimbursementVerificationReviewDetails";

// constants
import { PageTitles, ReimbursementVerificationReview as Constants } from "constants/global";

// hook
import { useReimbursementVerificationReview } from "containers/ReimbursementVerificationReview/useReimbursementVerificationReview";

// styles
import styles from "containers/ReimbursementVerificationReview/reimbursementVerificationReview.module.css";

const ReimbursementVerificationReview = () => {
	const {
		claimDetails,
		documents,
		loadingWithoutData,
		claimsLoading,
		enableApproveRejectButtons,
		isStatusApproved,
		isStatusRejected,
		rejectionReason,
		rejectionReasonErr,
		isRejectionReasonUpdated,
		handleSaveChanges,
		setRejectionReason,
		validateRejectionReason,
		handleRejectClaim,
		handleApproveClaim,
		goBack,
		handleDownload
	} = useReimbursementVerificationReview();

	if (loadingWithoutData) {
		return <Spinner />;
	}
	const reimRejectReasonClass = rejectionReason && isRejectionReasonUpdated ? styles?.filled : "";

	return (
		<div className="relative min-h-screen">
			{claimsLoading && <Spinner type="transparent" />}
			<div className={styles?.bg_curve}>{getIcon({ icon: "landingPageBackground" })}</div>
			<div className={styles?.bg_frame}>{getIcon({ icon: "businessDecisions" })}</div>
			<Head>{PageTitles.REIMBURSEMENT_VERIFICATION_REVIEW}</Head>
			<PageTitle showBackIcon={true} goBack={goBack} title={Constants.ROLE_HEADER} subTitle={Constants.ROLE_SUB_HEADER} />

			<div className={styles?.wrapper}>
				<ReimbursementVerificationReviewDetails claimDetails={claimDetails} documents={documents} handleDownload={handleDownload} />
				{isStatusRejected && (
					<Form layout="vertical" className="mt-6">
						<Form.Item
							initialValue={claimDetails?.verifier_remarks}
							style={{ width: "inherit" }}
							name={Constants.FIELD_REJECTION_REASON}
							label={<Label label={Constants.FIELD_REJECTION_REASON} classes={{ label: styles?.input_label }}></Label>}
							extra={
								rejectionReasonErr && <ErrorMessage message={`${rejectionReason ? Constants.INVALID_REJECTION_ERR : Constants.REQUIRED_ERR}`} classes="text-red-500"></ErrorMessage>
							}
						>
							<Input.TextArea
								id={Constants.FIELD_REJECTION_REASON}
								value={rejectionReason}
								onChange={(e) => setRejectionReason(e.target.value)}
								data-testid={Constants.FIELD_REJECTION_REASON}
								placeholder={Constants.REJECTION_REASON_PLACEHOLDER}
								className={`${styles?.input_textarea} ${rejectionReasonErr ? styles?.err : reimRejectReasonClass}`}
								onBlur={() => validateRejectionReason()}
							/>
						</Form.Item>
					</Form>
				)}
				<div className={styles?.action_buttons_wrapper}>
					{!isStatusApproved && (
						<ANTButton className={styles?.approve_button} disabled={!enableApproveRejectButtons || isRejectionReasonUpdated} onClick={handleApproveClaim}>
							{Constants?.APPROVE_BTN_LABEL}
						</ANTButton>
					)}
					{!isStatusRejected && (
						<ANTButton type="primary" danger className={styles?.reject_button} disabled={!enableApproveRejectButtons} onClick={handleRejectClaim}>
							{Constants?.REJECT_BTN_LABEL}
						</ANTButton>
					)}
					{isStatusRejected && (
						<Button
							type={!rejectionReason || rejectionReasonErr || !isRejectionReasonUpdated ? "disabled" : "active"}
							onClick={handleSaveChanges}
							label={Constants?.SAVE_CHANGES_LABEL}
						/>
					)}
				</div>
			</div>
		</div>
	);
};

export default ReimbursementVerificationReview;
